import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  UnexpectedServiceErrorGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import UsageAndAttitudeWidgetsEmptyResultGuard from './UsageAndAttitudeWidgetsEmptyResultGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicInaccessibleGuard widgetId={widgetId}>
      <UnexpectedServiceErrorGuard widgetId={widgetId}>
        <TopicIndexNotReadyGuard widgetId={widgetId}>
          <TopicLanguageNotSupportedGuard widgetId={widgetId}>
            <UsageAndAttitudeWidgetsEmptyResultGuard widgetId={widgetId}>
              {children}
            </UsageAndAttitudeWidgetsEmptyResultGuard>
          </TopicLanguageNotSupportedGuard>
        </TopicIndexNotReadyGuard>
      </UnexpectedServiceErrorGuard>
    </TopicInaccessibleGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
